// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btnGroup {\n  border-top: 1px solid #9e9e9e;\n  border-left: 1px solid #9e9e9e;\n  border-bottom: 1px solid #9e9e9e;\n  border-top-right-radius:0px !important;\n  border-bottom-right-radius:0px;\n}\n.shade {\n  background-color: whitesmoke\n}\n#arg-disabled-button.theme--light.v-btn.v-btn--disabled .v-btn__content .v-icon{\n    color: #4caf4fc0 !important;\n}\n.edit-allowance-container {\n  display: grid;\n  position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
